<template>
	<div>
		<ul class="order ovw mar_b">
			<li :class="dataType == ''?'on':''"><a href="javascript:;" @click="queryData('',1)"><span>全部订单</span></a><i></i></li>
			<li :class="dataType == '1'?'on':''"><a href="javascript:;" @click="queryData('1',1)"><span>寄存订单</span></a><i></i></li>
			<li :class="dataType == '-1'?'on':''"><a href="javascript:;" @click="queryData('-1',1)"><span>寄提订单</span></a></li>
		</ul>
		<ul class="record_list2">
			<li v-for="(item,index) in list" :key="index" @click="detail(item)">
				<div class="order-no"><span>单号：{{item.orderNo}}</span><span>{{item.orderType == 1 ? '寄存' : '寄提'}}</span></div>
				<div>
					<div class="product-item" v-for="(item2,index2) in item.items" :key="index2"><img :src="'/userfile/default/picture/' + item2.productID_simage" /><span>{{item2.productID_sname}}</span><h3>{{item2.num}}{{item2.unit}}</h3></div>
				</div>
				<div class="order-no">
					<span>下单时间：{{item.createTime.replace('T',' ')}}</span>
					<span class="text-right"><a href="javascript:;" class="detail-btn">查看详情</a></span>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
import {
  OrderInOut
} from "@/api/api.js"
export default {
  data () {
    return {
		dataType:'',
		list:[],
		page:1,
		size:20,
		isQuery:false
    }
  },
  methods:{
	  queryData(t,page){
		  let that = this;
		  if(that.isQuery){return;}

		  that.isQuery = true;
		  this.page = page; 
		  this.dataType = t;
		  if(this.page == 1){
			  this.list = [];
		  }

		  let query = {page:that.page,size:that.size,status:null};
	      if(that.dataType == '1' || that.dataType == '-1'){
			query.orderType = parseInt(that.dataType);
		  }

		  OrderInOut(query,function(res){
			  that.list = that.list.concat(res.data);
			  that.isQuery = false;
		  })
	  },
	  detail(t){
		  let that = this;
		  that.$router.push('jcjtdetail?id=' + t.id);
	  }
  },
  created:function(){
	  let that = this;
	  this.queryData(this.dataType,1);
	  window.onscroll = () => {
        let bottomOfWindow = document.documentElement.offsetHeight - document.documentElement.scrollTop - window.innerHeight <= 20
        if (bottomOfWindow  && !that.isQuery) {
          that.queryData(this.dataType,this.page + 1);
        }
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/wechat/jcjt.vue